export default __webpack_public_path__ + "static/media/img13.d85442e5.png";